import { styled } from '@mui/material/styles';
import Switch, { SwitchProps } from '@mui/material/Switch';

const OraSwitch = styled((props: SwitchProps) => (
  <Switch disableRipple {...props} />
))({});

export default OraSwitch;
